import { Route, Redirect } from 'react-router';

import { getAsyncRouteComponentLoader } from 'app/shared/utils/utils';
import { ConnectedPageTemplate } from 'app/shared/modules/pageTemplate/PageTemplate/ConnectedPageTemplate';

/* Homepage with AuthModal open routes */
const HOME_AUTH_MODAL_ROUTES = ['login', 'signup'];

export const LoginRoutes = (
  <Route
    name="accounts"
    component={({ routes, ...props }) => {
      const routeName = routes[routes.length - 1].name;
      const isAuthModalRoute = HOME_AUTH_MODAL_ROUTES.includes(routeName);
      return (
        <ConnectedPageTemplate
          target="accountPages"
          isHome={isAuthModalRoute}
          accountRoute={routeName}
          {...props}
        />
      );
    }}
  >
    <Route
      exact
      name="login"
      path="/account/login"
      getComponent={getAsyncRouteComponentLoader('ConnectedHome', () =>
        import('../home/Home/ConnectedHome'),
      )}
    />
    <Route
      exact
      name="openIdLogin"
      path="/account/openIdLogin"
      getComponent={getAsyncRouteComponentLoader('ConnectedHome', () =>
        import('../home/Home/ConnectedHome'),
      )}
    />
    <Route
      name="signup"
      path="/account/signup"
      exact
      getComponent={getAsyncRouteComponentLoader('ConnectedHome', () =>
        import('../home/Home/ConnectedHome'),
      )}
    />
    <Route
      name="profile"
      path="/account/profile"
      exact
      getComponent={getAsyncRouteComponentLoader('ConnectedProfilePage', () =>
        import('./ProfilePage/ConnectedProfilePage'),
      )}
    />
    <Route
      name="searches"
      path="/account/searches"
      exact
      getComponent={getAsyncRouteComponentLoader(
        'ConnectedSaveSearchDashboard',
        () =>
          import(
            '../saveSearch/SaveSearchDashboard/ConnectedSaveSearchDashboard'
          ),
      )}
    />
    <Redirect from="/login" to="/account/login" />
    <Redirect from="/signup" to="/account/signup" />
    <Redirect from="/profile" to="/account/profile" />
  </Route>
);
